import React, { useState } from 'react';
import { Settings as SettingsIcon, Save, X } from 'lucide-react';
import { Button } from './ui/Button';
import { Card } from './ui/Card';

interface SettingsProps {
  onSave: (settings: {
    provider: 'openai' | 'groq';
    apiKey: string;
  }) => void;
  currentProvider: 'openai' | 'groq';
  currentApiKey: string;
}

export function Settings({ onSave, currentProvider, currentApiKey }: SettingsProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [provider, setProvider] = useState<'openai' | 'groq'>(currentProvider);
  const [apiKey, setApiKey] = useState(currentApiKey);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave({ provider, apiKey });
    setIsOpen(false);
  };

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <Button
        onClick={() => setIsOpen(true)}
        className="rounded-full w-12 h-12 p-0 shadow-lg"
      >
        <SettingsIcon className="w-5 h-5" />
      </Button>

      {isOpen && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4">
          <Card className="w-full max-w-md relative">
            <button
              onClick={() => setIsOpen(false)}
              className="absolute right-4 top-4 text-gray-400 hover:text-gray-600"
            >
              <X className="w-5 h-5" />
            </button>

            <form onSubmit={handleSubmit} className="p-6">
              <h2 className="text-xl font-semibold mb-6">API Settings</h2>

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    AI Provider
                  </label>
                  <select
                    value={provider}
                    onChange={(e) => setProvider(e.target.value as 'openai' | 'groq')}
                    className="w-full rounded-lg border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                  >
                    <option value="openai">OpenAI</option>
                    <option value="groq">Groq</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    API Key
                  </label>
                  <input
                    type="password"
                    value={apiKey}
                    onChange={(e) => setApiKey(e.target.value)}
                    className="w-full rounded-lg border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                    placeholder={`Enter your ${provider === 'openai' ? 'OpenAI' : 'Groq'} API key`}
                  />
                </div>

                <Button type="submit" className="w-full">
                  <Save className="w-4 h-4 mr-2" />
                  Save Settings
                </Button>
              </div>
            </form>
          </Card>
        </div>
      )}
    </div>
  );
}